import { Option } from "uikit";

import { Map } from "../../../../../../services";

export function buildHouseSelectOptions(
	houses: Map.Search.House[] | undefined,
	houseQuery: string,
): Option<string>[] {
	const payload = [...(houses || [])];
	if (houseQuery) {
		const exist = payload.find((item) => item.number === houseQuery);
		if (!exist) {
			payload.unshift({ id: "query", number: houseQuery });
		}
	}

	return payload
		.reduce((accumulator, house) => {
			if (
				house.number === houseQuery &&
				!accumulator.some(
					(filteredHouse) => filteredHouse.number === house.number,
				)
			) {
				accumulator.unshift(house);
			} else if (
				house.number.includes(houseQuery ?? "") &&
				!accumulator.some(
					(filteredHouse) => filteredHouse.number === house.number,
				)
			) {
				accumulator.push(house);
			}

			return accumulator;
		}, [] as Map.Search.House[])
		.map((option) => ({
			key: option.id,
			label: option.number,
			value: option.number,
		}));
}

/** Enter without arrows: activeId is -2/-1 — take the first visible row, same as a click. */
export function pickHouseSelectOption(
	options: Option<string>[],
	activeId: number,
): Option<string> | undefined {
	if (!options.length) return undefined;
	if (activeId >= 0 && activeId < options.length) {
		return options[activeId];
	}
	return options[0];
}
